import * as React from 'react';
import {Video} from '@models/video-content';
import {Table, Button, Divider, Avatar} from 'antd';
import {FormattedMessage, injectIntl, intlShape} from 'react-intl';
import FormattedDateTime from "@components/custom/FormattedDateTime";
import {PaginationDefaultParams} from "@components/custom/Paginator";
import {VideoFileFlagOptions, VideoFileStatusOptions, VideoFileTypeOptions} from "@models/video-file";
import {NavLink} from "react-router-dom";
import {VideoFileStatus} from "@models/video-file";


type Props = {
  data: Video[],
  loading: boolean,
  deleteFn: (item: Video) => void;
  intl: intlShape.isRequired
  currentPage: number
};


const VideosTable: React.FC<Props> = props => {
  const {data, loading, currentPage} = props;
  const pageOffset = (currentPage - 1) * PaginationDefaultParams.count;
  
  const columns = [
    {
      title: <FormattedMessage id="app.index" defaultMessage={`Index`}/>,
      width: 30,
      dataIndex: 'id',
      key: 'id',
      render: (a, b, i) => <span>{i + 1 + pageOffset}</span>
    },
    {
      title: <FormattedMessage id="app.title" defaultMessage={`Title`}/>,
      width: 200,
      dataIndex: 'title',
      key: 'title',
      align:"right"
    },
    {
      title: <FormattedMessage id="app.type" defaultMessage={`Type`}/>,
      dataIndex: 'type',
      key: 'type',
      align:"center",
      render: (type) => {
        const obj = VideoFileTypeOptions.find(item => item.value == type);
        return obj ? obj.label : type
      }
    },
    {
      title: <FormattedMessage id="app.status" defaultMessage={`Status`}/>,
      dataIndex: 'status',
      key: 'status',
      align:"center",
      render: (type) => {
        const obj = VideoFileStatusOptions.find(item => item.value == type);
        return obj ? obj.label : type
      }
    },
    {
      title: <FormattedMessage id="app.flags" defaultMessage={`Flags`}/>,
      dataIndex: 'flags',
      key: 'flags',
      render: (type) => {
        const obj = VideoFileFlagOptions.find(item => item.value == type);
        return obj ? obj.label : ""
      }
    },
    {
      title: <FormattedMessage id="app.exception_message" defaultMessage={`Exception Message`}/>,
      dataIndex: 'files_info',
      key: 'files_info',
      align:"right",
      render: (files_info) => {
        return files_info?.exception_message
      }
    },
    {
      title: <FormattedMessage id="app.creation_date" defaultMessage={`Creation Date`}/>,
      width: 140,
      dataIndex: 'created_at',
      key: 'created_at',
      render: (text, record) => <FormattedDateTime date={text}/>
    },
    {
      title: '',
      key: 'actions',
      width: 120,
      align:"left",
      dataIndex: 'actions',
      render: (text, record) => {
        const canUpdate = record.status === VideoFileStatus.ACTIVE ||
          record.status === VideoFileStatus.DISABLE ||
          record.status === VideoFileStatus.READY;
        if (canUpdate) {
          return(
            <NavLink to={`/video-files/${record.id}/edit`}>
              <Button type="link" size={`small`}>
                <FormattedMessage id="app.edit" defaultMessage={`Edit`}/>
              </Button>
            </NavLink>
          );
          return null
        }
      },
    },
  ];
  
  
  return (
    <Table columns={columns}
           loading={loading}
           pagination={false}
           dataSource={data}
           rowKey='id'/>
  )
};

export default injectIntl(VideosTable);

